const COLORS = {
  sos:       '#dc2626',
  on_shift:  '#10b981',
  overdue:   '#f59e0b',
  off_shift: '#94a3b8',
};

const LABELS = {
  sos:       'people.status.sos',
  on_shift:  'people.status.onShift',
  overdue:   'people.status.overdue',
  off_shift: 'people.status.offShift',
};

/**
 * Pure status mapper for a staff row from /api/staff/positions/latest.
 * Mirrors getVehicleStatus(device, position) ergonomics — returns
 * { status, color, label } where label is an i18n key.
 *
 * @param {Object} row
 * @param {Object|null} row.sos
 * @param {Object|null} row.shift
 * @param {Object|null} row.lastFix
 * @param {Object} [opts]
 * @param {number} [opts.overdueMinutes=5]
 * @returns {{ status: 'sos'|'on_shift'|'overdue'|'off_shift', color: string, label: string }}
 */
export function getStaffStatus(row, opts) {
  const overdueMinutes = opts?.overdueMinutes ?? 5;
  if (row?.sos) {
    return { status: 'sos', color: COLORS.sos, label: LABELS.sos };
  }
  if (!row?.shift) {
    return { status: 'off_shift', color: COLORS.off_shift, label: LABELS.off_shift };
  }
  const fixTime = row.lastFix?.fixTime;
  if (!fixTime) {
    return { status: 'overdue', color: COLORS.overdue, label: LABELS.overdue };
  }
  const ageMs = Date.now() - new Date(fixTime).getTime();
  if (ageMs > overdueMinutes * 60_000) {
    return { status: 'overdue', color: COLORS.overdue, label: LABELS.overdue };
  }
  return { status: 'on_shift', color: COLORS.on_shift, label: LABELS.on_shift };
}
